import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bc49788"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pas-input" }
const _hoisted_2 = { class: "checkbox" }
const _hoisted_3 = {
  key: 0,
  class: "input-container"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "meet" }, "fit", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "slice" }, "cover", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "input-container"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "xMin" }, "min", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "xMid" }, "mid", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "xMax" }, "max", -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "input-container"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "YMin" }, "min", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "YMid" }, "mid", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "YMax" }, "max", -1))
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.preserve) = $event))
      }, null, 512), [
        [_vModelCheckbox, _ctx.preserve]
      ]),
      _createTextVNode(" Preserve ")
    ]),
    (_ctx.preserve)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createTextVNode(" Size "),
          _withDirectives(_createElementVNode("select", {
            class: "select is-small",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.size) = $event))
          }, _hoisted_6, 512), [
            [_vModelSelect, _ctx.size]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.preserve)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createTextVNode(" X alignment "),
          _withDirectives(_createElementVNode("select", {
            class: "select is-small",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.xAlignment) = $event))
          }, _hoisted_11, 512), [
            [_vModelSelect, _ctx.xAlignment]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.preserve)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createTextVNode(" Y alignment "),
          _withDirectives(_createElementVNode("select", {
            class: "select is-small",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.yAlignment) = $event))
          }, _hoisted_16, 512), [
            [_vModelSelect, _ctx.yAlignment]
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}